import { IOCTTPS } from "../../@types/ioc";

export const ActorTTPSSchema = {
  fields: [
    {
      name: "name",
      displayTitle: "Name",
      sortable: true,
      component: (d: IOCTTPS) => d.name,
      style: { width: "50%" }
    },
    {
      name: "description",
      displayTitle: "Description",
      sortable: true,
      component: (d: IOCTTPS) => d.description,
      style: { width: "50%" },
      className: "overflow-ellipsis"
    }
  ]
};
